<template lang='pug'>
  .basic-info-view(v-loading="loading")
    .card-title
      p {{ $t(cardTitle) }}
    hr.divider
    el-row.title-row(
      :gutter="20"
    )
      el-col(:span="10") {{ $t('子项目名称') }}
      el-col(:span="10") {{ $t('品牌线') }}
    el-row.content-row(
      :gutter="20"
    )
      el-col(:span="10") {{ data.sub_final_scope_name }}
      el-col(:span="10") {{ data.brand_line_name }}
    el-row.title-row(
      :gutter="20"
    )
      el-col(:span="10") {{ $t('投放时间') }}
      el-col(:span="10") {{ $t('投放预算') }}
    el-row.content-row(
      :gutter="20"
    )
      el-col(:span="10") {{ data.start_date }} ~ {{ data.end_date }}
      el-col(:span="10") {{ data.budget / 10000 | numberWithCommas(1) }} {{ $t('万元') }}
    el-row.title-row(
      :gutter="20"
    )
      el-col(:span="10") {{ $t('核心目标') }}
      el-col(:span="10") {{ $t('是否有IO') }}
    el-row.content-row(
      :gutter="20"
    )
      el-col(:span="10")
        span(v-for="(item, idx) in data.sub_final_scope_core_target")
          span {{ item.core_target_name }}
          span(
            v-if="idx !== data.sub_final_scope_core_target.length - 1"
            style="margin: 0 3px"
          ) /

      el-col(:span="10") {{ data.is_sow_io === 1 ? $t('是') : $t('否') }}
    el-row.title-row(
      :gutter="20"
    )
      el-col(:span="10") {{ $t('品牌/产品卖点') }}
    el-row.content-row(
      :gutter="20"
    )
      el-col(:span="10") {{ data.selling_point }}
    el-row.title-row(
      :gutter="20"
    )
      el-col(:span="10") {{ $t('子项目背景') }}
    el-row.content-row(
      :gutter="20"
    )
      el-col(:span="10") {{ data.remark != null ? data.remark : '—'}}
    hr.divider
    div(
      v-if="showRejectBtn"
      style="text-align:right"
    )
      el-button(
        v-if="isBypass"
        @click="visible = true"
        type="text"
      ) {{ $t('驳回素材') }}
      el-dropdown(
        v-else
        type="primary"
        @command="handleCommand"
      )
        el-button(
          type="primary"
        ) {{ $t('审核操作') }}
          i.el-icon-arrow-down.el-icon--right
        el-dropdown-menu(
          slot="dropdown"
        )
          el-dropdown-item(
            command="handleReject"
          ) {{ $t('拒绝') }}
    template(
      v-for="(item, i) in data.media_type"
    )
      div {{ $t('媒体形式') }}{{ i + 1 }}
      media-type-item-view(
        :item="item"
        :key="i"
        :showMaterialInfo="showMaterialInfo"
      )

    el-dialog(
      :title="$t('提示')"
      :visible.sync="visible"
    )
      p(style="text-align:left;width: 100%") {{ $t('当前素材信息将被驳回，请确定是否继续。') }}
      el-form(
        ref="form"
        :model="form"
        :rules="rules"
      )
        el-form-item(
          :label="$t('拒绝理由') + ':'"
          prop="remark"
        )
          el-input(
            v-model="form.remark"
            type="textarea"
            :rows="3"
            style="width: 314px"
            :placeholder="$t('拒绝理由不多于500字')"
          )
      footer-button(
        @confirm="handleConfirm"
        @cancel="handleCancel"
      )
</template>

<script>
import axios from 'axios'
import MediaTypeItemView from '../components/MediaTypeItemView'
import FooterButton from '@/components/FooterButton'
import { numberWithCommas } from '@/umcc/util'

export default {
  components: {
    MediaTypeItemView,
    FooterButton
  },
  data () {
    let validateIntro = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('请输入拒绝理由')))
      } else if (value.length > 500) {
        callback(new Error(this.$t('拒绝理由不多于100字')))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      data: {
      },
      form: {
        remark: ''
      },
      rules: {
        remark: [
          {
            required: true, validator: validateIntro, trigger: 'blur'
          }
        ]
      },
      visible: false
    }
  },
  filters: {
    numberWithCommas
  },
  props: {
    cardTitle: {
      type: String,
      default () {
        return this.$t('项目信息')
      }
    },
    showRejectBtn: {
      type: Boolean,
      default: false
    },
    showMaterialInfo: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    campaignId () {
      return this.$store.state.campaign.id
    },
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    },
    isBypass () {
      if (this.$store.state.campaign.campaignSurvey == null || this.$store.state.campaign.campaignSurvey == null) return false
      return this.$store.state.campaign.campaignSurvey.is_bypass === 1
    }
  },
  async mounted () {
    await this.$store.dispatch('campaign/updateECCampaignInfo')
    this.getSOW()
  },
  methods: {
    handleCommand (command) {
      this.$emit('openDialog', true)
    },
    handleConfirm (result) {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.onConfirm()
        }
      })
    },
    handleCancel () {
      this.visible = false
      this.$refs['form'].clearValidate()
    },
    getSOW () {
      this.loading = true
      axios.get('/management/ec/getSOW', {
        params: {
          sub_final_scope_id: this.subFinalScopeId
        }
      })
        .then(res => {
          this.data = res
          this.$store.commit('campaign/setSubFinalScopeInfo', this.data)
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    },
    onConfirm () {
      this.visible = false
      this.$emit('onConfirm', this.form.remark)
    }
  }
}
</script>

<style lang='stylus'>
.basic-info-view
  .divider
    margin 24px 0
  .title-row
    margin-bottom 0
    color #999999
  .content-row
    margin-top 0
    color #5e5e5e
    margin-left -10px !important
  .el-dialog
    width 452px
    .el-form
      width 100%
      .el-form-item__error
        margin-left 80px
    .el-dialog__body
      padding-left 24px
      padding-right 24px
      display flex
      flex-direction column
      align-items center
      .el-textarea
        textarea.el-textarea__inner
          height 90px
    .footer-button
      margin-top 0
      text-align right
      width 100%
.target-audience-item,.campaign-io-view
  border 1px dashed #d8d8d8
  padding 0 24px
  width 650px
  margin-bottom 24px
.footer-button
  margin-top 24px
  text-align center
</style>
